<template>
	<div>
		<goal-status-report />
	</div>
</template>

<script>
	// Reports
	import GoalStatusReport from '@/components/reports/GoalStatusReport';

	export default {
		components: {
			GoalStatusReport
		},
		data() {
			return {};
		},
		created() {
			this.$store.dispatch('setPageTitle', `${this.$term('employee', { case: 'title' })} Goals`);
		}
	};
</script>

<style></style>
